import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../shared/ui/kit/utils';

interface SettingRowProps {
    title: string;
    description: string;
    children: React.ReactNode;
    danger?: boolean;
    last?: boolean;
}

export const SettingRow: React.FC<SettingRowProps> = ({
    title,
    description,
    children,
    danger = false,
    last = false,
}) => {
    return (
        <motion.div
            whileHover={{ backgroundColor: danger ? 'rgba(239, 68, 68, 0.06)' : 'rgba(0, 0, 0, 0.02)' }}
            transition={{ duration: 0.15 }}
            className={cn(
                'flex items-center justify-between gap-4 px-4 py-3.5 cursor-default',
                !last && 'border-b border-[var(--border)]',
                danger && 'bg-red-500/[0.03]'
            )}
        >
            <div className="flex-1 min-w-0">
                <motion.h4 
                    layout="position"
                    className={cn(
                        'text-[13px] font-medium mb-0.5',
                        danger ? 'text-red-600 dark:text-red-400' : 'text-[var(--text)]'
                    )}
                >
                    {title}
                </motion.h4>
                <p className="text-[11px] text-[var(--text-muted)] leading-relaxed">
                    {description}
                </p>
            </div>
            <div className="flex-shrink-0">
                {children}
            </div>
        </motion.div>
    );
};